// src/contexts/VideoContext.js
import React, { createContext, useState, useContext } from "react";

const VideoContext = createContext();

export const VideoProvider = ({ children }) => {
  const [currentVideo, setCurrentVideo] = useState("idle");

  const setVideoState = state => {
    setCurrentVideo(state);
  };

  return (
    <VideoContext.Provider value={{ currentVideo, setVideoState }}>
      {children}
    </VideoContext.Provider>
  );
};

export const useVideo = () => {
  return useContext(VideoContext);
};
